import type { RefObject } from "react";
import type { MembershipProduct, SpaceProfile } from "../SpaceType";
import { membershipListIconUrl, sortMembershipProductsForHome } from "../spacePageUtils";
import { SpaceHomeMembershipSection } from "../components/SpaceHomeMembershipSection";

/** 订阅卡片列表 */
export function SpaceHomeSubscribeCards(props: {
  spaceId: string;
  products: MembershipProduct[];
  isLoggedIn: boolean;
  spaceProfile: SpaceProfile | null;
  listRef: RefObject<HTMLUListElement>;
  onLoginRequest: () => void;
}): JSX.Element {
  const { spaceId, products, isLoggedIn, spaceProfile, listRef, onLoginRequest } = props;
  const sortedProducts = sortMembershipProductsForHome(products);
  return (
    <ul
      ref={listRef}
      id="space-home-membership-list"
      className="space-membership-list"
      aria-label="会员产品列表"
    >
      {sortedProducts.map((row) => {
        const cardIcon = membershipListIconUrl(row);
        return (
          <li key={row.spaceProductId} className="space-membership-item">
            <div className="space-m-body">
              {cardIcon ? (
                <div className="space-m-icon-wrap">
                  <img
                    className="space-m-icon"
                    src={cardIcon}
                    alt=""
                    width={56}
                    height={56}
                    loading="lazy"
                    decoding="async"
                  />
                </div>
              ) : null}
              <div className="space-m-copy">
                <div className="space-membership-name">{row.displayName}</div>
                <p className="space-membership-intro">{row.description}</p>
              </div>
              <div className="space-membership-right">
                <SpaceHomeMembershipSection
                  spaceId={spaceId}
                  row={row}
                  isLoggedIn={isLoggedIn}
                  onLoginRequest={onLoginRequest}
                  spaceProfile={spaceProfile}
                />
              </div>
            </div>
          </li>
        );
      })}
    </ul>
  );
}
